export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-foreground-900 font-bold text-lg font-heading">91免费在线视频</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              专注提供零缓冲观影服务，蓝光画质与超清剧场任你选。海量高清电影和热门电视剧实时更新，在线播放稳定流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <a href="#hero" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">首页</a>
              </li>
              <li>
                <a href="#ranking" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">热播排行</a>
              </li>
              <li>
                <a href="#cards" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">精选推荐</a>
              </li>
              <li>
                <a href="#updates" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">最新动态</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3 whitespace-nowrap">内容分类</h4>
            <ul className="space-y-2">
              <li>
                <a href="#index" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">专题合集</a>
              </li>
              <li>
                <a href="#topics" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">热门话题</a>
              </li>
              <li>
                <a href="#media" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">最新上架</a>
              </li>
              <li>
                <a href="#carousel" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">精彩专题</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3 whitespace-nowrap">帮助支持</h4>
            <ul className="space-y-2">
              <li>
                <a href="#faq" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">常见问答</a>
              </li>
              <li>
                <a href="#about" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</a>
              </li>
              <li>
                <a href="#contact" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</a>
              </li>
              <li>
                <a href="#app" className="text-xs md:text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">移动观影</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6 mb-6">
          <h4 className="text-sm font-bold text-foreground-900 mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-400">优质合作伙伴持续招募中，敬请期待。</p>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            &copy; 2026 91免费在线视频 - 蓝光画质高清电影大全免费看。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}